/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** InStore = Reward can be redeemed in store, Delivery = Reward can be redeemed in delivery, Pickup = Reward can be redeemed in pickup, All = Reward can be redeemed in all channels */
export type RedemptionChannel = 'All' | 'Delivery' | 'InStore' | 'Kiosk' | 'Outpost' | 'Pickup';

/** PREMIUM = Reward is part of loyalty program, NON_PREMIUM = Reward is outcome of challenge/other outlet but not loyalty program */
export type RewardType = 'NON_PREMIUM' | 'PREMIUM';

export type BagLoyaltyRewardsDeferredQueryVariables = Exact<{ [key: string]: never }>;

export type BagLoyaltyRewardsDeferredQuery = {
  readonly cart: {
    readonly __typename: 'Order';
    readonly id: string;
    readonly availableRewards: ReadonlyArray<{
      readonly __typename: 'Reward';
      readonly id: string;
      readonly name: string;
      readonly expirationDate: string | null;
      readonly rewardType: Types.RewardType;
      readonly redeemable: boolean;
      readonly redeemableAt: string | null;
      readonly redemptionChannel: Types.RedemptionChannel;
      readonly terms: string;
      readonly assetUrl: string | null;
    }> | null;
    readonly eligiblePointRewards: ReadonlyArray<{
      readonly __typename: 'PointsReward';
      readonly id: string;
      readonly points: number;
      readonly redeemable: boolean;
      readonly assetUrl: string | null;
      readonly name: string;
    }> | null;
  } | null;
};

export const BagLoyaltyRewardsDeferredDocument = gql`
  query BagLoyaltyRewardsDeferred {
    cart {
      id
      __typename
      availableRewards {
        id
        __typename
        name
        expirationDate
        rewardType
        redeemable
        redeemableAt
        redemptionChannel
        terms
        assetUrl
      }
      eligiblePointRewards {
        id
        __typename
        name: displayName
        points
        redeemable
        assetUrl
      }
    }
  }
`;

export function useBagLoyaltyRewardsDeferredQuery(
  options?: Omit<Urql.UseQueryArgs<BagLoyaltyRewardsDeferredQueryVariables>, 'query'>,
) {
  return Urql.useQuery<BagLoyaltyRewardsDeferredQuery, BagLoyaltyRewardsDeferredQueryVariables>({
    query: BagLoyaltyRewardsDeferredDocument,
    ...options,
  });
}
